/**
 * 此类作为设置全局变量的类，生命周期随单页面一同
 */
const global = {
    appLang: 'zh-CN',
    serviceInfoMap: {},
    serviceList: [],
    pjCateList: [],
    rtmRegionList: [],

    auth: {
        // 所在公司map
        companyMap: {},
        // 所在公司ID list
        inCompanies: [],
        // 能创建项目的公司ID list
        canCreatePjCy: [],
        // 用户中心
        userCenterMenu: [],
        userInfo: []
    },

    service: {
        ALL: 99, //全部服务
        RTM: 0, //实时数据传输
        LDN: 1, //云上推送系统
        LOG: 2, //日志
        ALT: 4, //实时翻译
        ICS: 6, //智能机器人
        DTS: 7, //文本审核
        STT: 8, //语音识别
        LHP: 9, //智能客服
        PIR: 10, //图片审核
        AUR: 11, //音频审核
        VIR: 12, //视频审核
        STN: 13, //语音翻译
        RTV: 15, //实时视频
        RTA: 16, //实时音频
        RTVT: 17, //实时语音翻译
        RTAU: 18, //实时音视频审核
    },
}

export default global
